import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';
import { Folder, WorkspaceItem } from '@primatoo-ms-organization';
import {
  FolderCreateRequest,
  FolderCreateResponse,
  FolderUpdateRequest,
  FolderUpdateResponse,
} from '@ms-organization-entities';
import { WorkspaceRenameRequest } from '@pt/pt-models';
import { DeleteEntityServiceInterface } from '../interface/delete-entity-service-interface';

@Injectable({
  providedIn: 'root',
})
export class FolderService implements DeleteEntityServiceInterface {
  private readonly endPoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    this.endPoint = this.config.endPoint + '/api/org/folders/';
  }

  public delete(id: number): Observable<any> {
    const url = this.endPoint + `${id}/`;
    return this.httpClient.delete<any>(url);
  }

  getDocDependencies(id: number): Observable<any> {
    return EMPTY;
  }

  public findAllFolders(): Observable<Folder[]> {
    const url = this.endPoint; // + `?page=0&size=2000&sort=id,ASC`;
    return this.httpClient.get<Folder[]>(url);
  }

  public findById(folderId: number): Observable<Folder> {
    const url = this.endPoint + `${folderId}/`;
    return this.httpClient.get<Folder>(url);
  }

  public create(
    request: FolderCreateRequest
  ): Observable<FolderCreateResponse> {
    const url = this.endPoint;
    return this.httpClient.post<FolderCreateResponse>(url, request);
  }

  public update(
    id: number,
    request: FolderUpdateRequest
  ): Observable<FolderUpdateResponse> {
    const url = this.endPoint + `${id}/`;
    return this.httpClient.put<FolderUpdateResponse>(url, request);
  }

  public rename(
    id: number,
    request: WorkspaceRenameRequest
  ): Observable<WorkspaceItem> {
    const url = this.endPoint + `${id}/rename`;
    return this.httpClient.patch<WorkspaceItem>(url, request);
  }

  getEndPoint(): string {
    return this.endPoint;
  }

  deleteMultiple(ids: number[]): Observable<{ failed: number[] }> {
    return undefined;
  }
}
